export const data = {
    name: "Water Chemicals",
    layout: [],
};
export default data;